import React from "react";
import FunnelTable from "./FunnelTable";
import FunnelChartCard from "./FunnelChartCard";
import styles from "./FunnelInsightCard.module.css";

const renderBullets = (items = []) =>
  items.length ? (
    <ul className={styles.list}>
      {items.map((item, idx) => (
        <li key={`${item}-${idx}`}>{item}</li>
      ))}
    </ul>
  ) : null;

const renderParagraphs = (items = []) =>
  items.length
    ? items.map((text, idx) => (
        <p key={`${text}-${idx}`} className={styles.paragraph}>
          {text}
        </p>
      ))
    : null;

const FunnelInsightCard = ({ title, kicker, badge, sections = [] }) => (
  <div className={styles.card}>
    {title ? (
      <div className={styles.header}>
        <div className={styles.titleBlock}>
          {kicker ? <span className={styles.kicker}>{kicker}</span> : null}
          <h4 className={styles.title}>{title}</h4>
        </div>
        {badge ? <span className={styles.badge}>{badge}</span> : null}
      </div>
    ) : null}
    {sections.map((section, idx) => (
      <div key={`${section.title || "section"}-${idx}`} className={styles.section}>
        {section.title ? (
          <div className={styles.sectionTitle}>{section.title}</div>
        ) : null}
        {section.meta ? <div className={styles.metaRow}>{section.meta}</div> : null}
        {section.chart ? (
          <FunnelChartCard
            title={section.chartTitle}
            subtitle={section.chartSubtitle}
            config={section.chart}
          />
        ) : null}
        {section.table ? (
          <div className={styles.tableScrollWrap}>
            <FunnelTable table={section.table} />
          </div>
        ) : null}
        {renderBullets(section.bullets)}
        {renderParagraphs(section.paragraphs)}
        {section.verdict ? (
          <p className={styles.verdict}>{section.verdict}</p>
        ) : null}
      </div>
    ))}
  </div>
);

export default FunnelInsightCard;
